// extracted by mini-css-extract-plugin
export default {"AffichageMesuresSuivies":"AffichageMesuresSuivies_AffichageMesuresSuivies__vsJxW","Mesures":"AffichageMesuresSuivies_Mesures__iMVHx"};